import scribe from './scribe';
import sessionService from './session-service';
import ENDPOINTS from 'tradera-constants/endpoints';
import { defaultClient as httpClient } from 'tradera-utils/http';

function trackItemPublished(draft) {
    var isFromTemplate = isDraftFromTemplate(draft);
    scribe.sendSessionDuration(
        sessionService.getElapsedMillis(),
        isFromTemplate
    );
}

function prepareForPublish(draft) {
    draft.shippingOptions = draft.shippingOptions.filter(item => !!item.type);
    draft.descriptionLanguageCodeIso2 =
        draft.descriptionLanguageCodeIso2 || 'sv';
    draft.currency = draft.currency || 'SEK';
}

function isNullOrUndefined(val) {
    return val === null || val === undefined;
}

function isDraftFromTemplate(draft) {
    return draft && !isNullOrUndefined(draft.templateId);
}

const publish = async (draft, hasTraderaPayConsent) => {
    prepareForPublish(draft);
    const response = await httpClient.post(ENDPOINTS.SELLING_ITEM_PUBLISH, {
        draft: draft,
        hasTraderaPayConsent: hasTraderaPayConsent
    });
    trackItemPublished(draft);
    if (response.data.errorCode) {
        throw response.data;
    }

    return response.data;
};

export default {
    publish
};
